// extracted by mini-css-extract-plugin
module.exports = {"btn_wrap":"AlertModal_btn_wrap__16jBZ","btn":"AlertModal_btn__35vG3","gray":"AlertModal_gray___O1qv","gold":"AlertModal_gold__2iPzj"};